module.exports = __webpack_public_path__ + "static/adam-whitlock-unsplash-a7d4302bbfe309bfb0c4eb944d822b3b.jpg";